<template>
  <el-select v-model="selectJob" placeholder="请选择职务属性" @change="onSelectJobChanged">
    <el-option
      v-for="item in jobs"
      :key="item.id"
      :label="item.label"
      :value="item.label">
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: "selectJobGrade",
  //lists 选中的职务   type:局级 或 部门级
  props:['job'],
  data(){
    return{
      selectJob:'',
      jobs:[],
    }
  },
  watch:{
    job:{
      immediate:true,
      deep:true,
      handler(val){
        this.selectJob=val;
      }
    }
  },
  mounted() {
    this.$commonConfig.getPostAttributes().then(res=>{
      this.jobs=res;
    }).catch(error=>{
      this.jobs=error
    })
  },
  methods:{
    onSelectJobChanged(e){
      this.$emit('onSelectJobChanged',e)
    }
  }
}
</script>

<style scoped>

</style>
